<template lang="pug">
  .alert
    .row
      .col
        .h7 ATTENTION
        .message {{getMessage()}}
      .col
        .dismiss
          a(@click.prevent="$emit('dismissPasswordExpirationAlert')") DISMISS
        router-link.btn.btn-primary(to="change_password") Change Password
</template>

<script>
export default {
  name: 'PasswordExpirationAlert',
  props: {
      daysUntilPasswordExpires: {
          type: Number,
          default: null,
      },
  },
  methods: {
    getMessage() {
      return this.daysUntilPasswordExpires
        ? `Your password expires in ${this.daysUntilPasswordExpires} ${this.daysUntilPasswordExpires === 1 ? 'day' : 'days'}.`
        : 'Your password is going to expire soon.';
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
.h7 {
  color: #1e1432;
  margin-bottom: 0.5rem;
}

.message {
  @extend .body-3;
  color: #1e1432;
}

.dismiss {
  @extend .body-3;
  text-align: right;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.dismiss:hover {
  text-decoration: underline;
  cursor: pointer;
}

.alert {
  background-color: #f8eeee;
  border: 1px solid #dbbfc1;
}

.btn {
  float: right;
}
</style>